import axios from "axios";


export default {
    addNewSifra(sifra_val) {
        try {
            return axios.post("https://app-psod.cratis.cloud/api/sifra", {
                params: {
                    sifra_val
                },
                credentials: true,
            });
        } catch (err) {
            console.log(err);
        }
    },
    editSifra(sifra_val) {
        try {
            return axios.put("https://app-psod.cratis.cloud/api/sifra/"+sifra_val.uid, {
                params: {
                    sifra_val
                },
                credentials: true,
            });
        } catch (err) {
            console.log(err);
        }
    },
    deleteSifra(uid) {
        try {
            return axios.delete("https://app-psod.cratis.cloud/api/sifra/"+uid, {
                params: {
                },
                credentials: true,
            });
        } catch (err) {
            console.log(err);
        }
    },
    getAllSifra() {
        try {
            return axios.get("https://app-psod.cratis.cloud/api/sifra");
        } catch (err) {
            console.log(err);
        }
    },


}